import apiCall from '../index'

const apiService = '/api-seguimiento/api/v1/reporte/'

const service = {
  principal(params) {
    const query = `?periodo=${params.periodo}&anio=${params.anio}&tipo_filtro=${params.tipoFiltro}`
    return new Promise((resolve, reject) => {
      apiCall
        .get(`${apiService}reportePrincipal${query}`)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  objetivoDetalle(params) {
    const query = `?tipoObjetivoId=${params.id}&periodo=${params.periodo}&anio=${params.anio}&tipo_filtro=${params.tipoFiltro}`
    return new Promise((resolve, reject) => {
      apiCall
        .get(`${apiService}objetivo-detalle${query}`)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  medidaDetalle(params) {
    console.log(params)
    const query = `?medidaId=${params.id}&anio=${params.anio}&tipo_filtro=${params.tipoFiltro}`
    return new Promise((resolve, reject) => {
      apiCall
        .get(`${apiService}medida-detalle${query}`)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  anioPeriodo(params) {
    const query = `?periodo=${params.periodo}&anio=${params.anio}`
    return new Promise((resolve, reject) => {
      apiCall
        .get(`${apiService}list_anio${query}`)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
}

export default service
